import { BackButton } from '../../components/BackButton';
import { StepProgress } from '../../components/StepProgress';
import { Bar } from './ActionBar.styles';
import type { ActionBarProps } from './ActionBar.types';

export function ActionBar({
  onBack,
  backAriaLabel = 'Go back',
  currentStep = 1,
  totalSteps,
  progressLabel,
}: ActionBarProps) {
  const showProgress = totalSteps != null && totalSteps > 0;

  if (!onBack && !showProgress) {
    return null;
  }

  return (
    <Bar>
      {onBack && <BackButton variant="contained" onClick={onBack} ariaLabel={backAriaLabel} />}
      {showProgress && (
        <StepProgress currentStep={currentStep} totalSteps={totalSteps} label={progressLabel} />
      )}
    </Bar>
  );
}
